// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcf_a bho_ke","ListItemIcon--empty":"bcf_b bho_fl"};